import { render, staticRenderFns } from "./userDealer.vue?vue&type=template&id=57ff31ae&"
import script from "./userDealer.vue?vue&type=script&lang=js&"
export * from "./userDealer.vue?vue&type=script&lang=js&"
import style0 from "./userDealer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports